import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { CURRENT_SEASON } from '@/lib/season';

interface Fixture {
  id: string;
  fixture_id: number;
  home_team: string;
  away_team: string;
  matchday: number;
  season: string;
  kickoff_time: string;
  venue?: string;
  status: string;
  home_score?: number;
  away_score?: number;
  home_win_odds?: number;
  draw_odds?: number;
  away_win_odds?: number;
  bookmaker?: string;
  last_updated: string;
}

export const useManagerUpcomingFixtures = (season: string = CURRENT_SEASON, competitionId?: number) => {
  return useQuery({
    queryKey: ['manager-upcoming-fixtures', season, competitionId],
    enabled: competitionId != null,
    queryFn: async () => {
      const now = new Date().toISOString();

      let query = supabase
        .from('fixtures')
        .select('*')
        .eq('season', season)
        .eq('status', 'NS')
        .gte('kickoff_time', now)
        .order('kickoff_time', { ascending: true });
      if (competitionId != null) query = query.eq('competition_id', competitionId);

      const { data, error } = await query;

      if (error) {
        console.error('Error fetching manager upcoming fixtures:', error);
        throw error;
      }

      return data as Fixture[];
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
